/* eslint-disable camelcase */
import { createSelector } from 'reselect';
import { feature } from 'topojson-client';
import { geoCentroid } from 'd3-geo';
import world from 'theme/charts/maps/world-110m.json';
import extraIsoA2 from 'theme/charts/maps/iso-a2';

export default createSelector(
  (state) => state.aggr.payload,
  (_, key) => key,
  (payload, key) => {
    let result = {};

    if (!payload[key] || !payload[key].data) return [];

    const { features } = feature(world, world.objects[Object.keys(world.objects)[0]]);
    let points = {};

    features.forEach((feat) => {
      points = {
        ...points,
        [feat.properties.ISO_A2]: {
          coordinates: geoCentroid(feat),
          name: feat.properties.NAME,
        },
      };
    });

    const {
      data: {
        aggregations: {
          results: { buckets },
        },
      },
    } = payload[key];

    buckets.forEach((marker) => {
      const {
        key: countryKey,
        current_period: {
          total_quantity: { value },
        },
      } = marker;

      if (value > 0) {
        if (points[countryKey]) {
          const { name, coordinates } = points[countryKey];

          const quantity =
            result[countryKey] && result[countryKey].quantity
              ? result[countryKey].quantity + value
              : value;
          result = { ...result, [countryKey]: { country: name, coordinates, quantity } };
        } else if (extraIsoA2[countryKey]) {
          const { name, coordinates } = points[extraIsoA2[countryKey]];

          const quantity =
            result[extraIsoA2[countryKey]] && result[extraIsoA2[countryKey]].quantity
              ? result[extraIsoA2[countryKey]].quantity + value
              : value;
          result = {
            ...result,
            [extraIsoA2[countryKey]]: { country: name, coordinates, quantity },
          };
        }
      }
    });

    return Object.keys(result).map((k) => result[k]);
  },
);
